var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
// import { AxiosError } from 'axios';
import DataTable from '@/components/data-table/DataTable';
import PageHeader from '@/components/page-header/PageHeader';
import { LogKey } from '@/models/LogKey';
import SelectFilter from '@/components/select-filter/SelectFilter';
import { formatDate as format } from '@/support/String';
import { Log } from '@/models/Log';
import { DateTime } from 'luxon';
import { RolesEnum } from '@/items/Roles';
// import ErrorHandler from '@/support/ErrorHandler';
// import { Options } from '@/components/mi-dialog/MiDialog';
let Logs = class Logs extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'Audits';
        this.logKeys = [];
        this.selectedLogKeyId = '';
        this.fromDate = DateTime.local().toFormat('yyyy-LL-dd').toString();
        this.fromTime = '00:00';
        this.toDate = DateTime.local().toFormat('yyyy-LL-dd').toString();
        this.toTime = '23:59';
        this.isShowingFromPickerDate = false;
        this.isShowingFromPickerTime = false;
        this.isShowingToPickerDate = false;
        this.isShowingToPickerTime = false;
        this.visible = {
            search: false,
            total: true,
            limit: true,
            pagination: true,
            checkboxes: false,
        };
    }
    mounted() {
        this.fetchKeys();
    }
    fetchKeys() {
        new LogKey()
            .limit(100)
            .all()
            .then((logKeys) => {
            this.logKeys = logKeys;
        });
    }
    get logsFilter() {
        const filter = {
            action: this.selectedLogKeyId,
            period: this.period,
        };
        return filter;
    }
    get period() {
        if (!this.fromTime.length || !this.toTime.length || !this.fromDate.length || !this.toDate.length) {
            return [];
        }
        return [`${this.fromDate} ${this.fromTime}`, `${this.toDate} ${this.toTime}`];
    }
    get canFetchLogs() {
        if (this.selectedLogKeyId.length &&
            this.toTime.length &&
            this.toDate.length &&
            this.fromDate.length &&
            this.fromTime.length) {
            return true;
        }
        return false;
    }
    get tableOptions() {
        return {
            name: {
                singular: `${this.selectedLogKeyId} ${this.$tc('logs.title', 1)}`,
                plural: `${this.selectedLogKeyId} ${this.$tc('logs.title', 1)}`,
            },
            headers: [
                {
                    text: 'datum',
                    value: 'created_at',
                    transform: (created_at) => {
                        return DateTime.fromSQL(created_at).toFormat('dd-LL-yyyy HH:mm').toString();
                    },
                    sortable: {
                        key: 'created',
                        order: 'ASC',
                    },
                    width: '20%',
                },
                {
                    text: 'Gebruiker',
                    value: 'user',
                    transform: (user) => user && user.name || this.$tc('system'),
                    sortable: {
                        key: 'created',
                        order: 'ASC',
                    },
                    width: '20%',
                },
                {
                    text: 'Omschrijving',
                    value: 'description',
                },
            ],
            actions: [],
            filters: [],
            model: new Log().filter(this.logsFilter).include('user').limit(200),
        };
    }
    get isAuthorized() {
        return this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.TRAINER]);
    }
};
Logs = __decorate([
    Component({
        components: {
            DataTable,
            PageHeader,
            SelectFilter,
        },
        filters: {
            formatTime(time) {
                if (!time) {
                    return '';
                }
                if (time === '00:00:00') {
                    return '-';
                }
                const parts = time.split(':');
                return `${parts[0]}:${parts[1]}`;
            },
            formatDate(date) {
                return !date ? '' : format(date, 'dd-LL-yyyy');
            },
            formatKey(key) {
                return key.replace(':', ' ');
            },
        },
    })
], Logs);
export default Logs;
